const isServer = typeof window === 'undefined';

const noop = () => undefined;
const voidDecorator = (target, key, descriptor) => {
  descriptor.value = noop;
  delete descriptor.get;
};

export const parseMultipleQueryParams = (query) => {
  const escapedQuery = [];
  Object.keys(query).forEach((key) => {
    escapedQuery.push(`${key}=${encodeURIComponent(decodeURIComponent(query[key]))}`);
  });
  return escapedQuery.join('&');
};

export const clientOnly = isServer ? voidDecorator : noop;
export const serverOnly = isServer ? noop : voidDecorator;



// WEBPACK FOOTER //
// ./spa/utils.jsx